import { motion } from "framer-motion";
import { Handshake } from "lucide-react";

export default function Partnership() {
  return (
    <section
      id="partnership"
      data-testid="partnership-section"
      className="relative py-24 sm:py-32 bg-[#0F2647] text-[#F5EBD9] border-y border-[#F5EBD9]/10 overflow-hidden"
    >
      <div className="absolute inset-0 sunset-glow opacity-40 pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-8 lg:gap-12 items-center"
        >
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#F5892E]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
                Главен партньор
              </span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mb-6">
              Организирано от <span className="text-[#F5892E]">Иво Димовски</span>
              <br />в партньорство с{" "}
              <span className="text-[#F5892E]">КСБ Варна</span>.
            </h2>
            <p className="text-lg text-[#F5EBD9]/75 leading-relaxed max-w-[58ch] mb-6">
              Събитието е организирано от Иво Димовски съвместно с Камарата на строителите
              в България — Областно представителство Варна. Партньор, който гарантира
              качеството на разговора и на хората в стаята.
            </p>
            <div className="inline-flex items-center gap-3 text-xs font-mono uppercase tracking-[0.28em] text-[#F5EBD9]/70">
              <Handshake className="w-4 h-4 text-[#F5892E]" strokeWidth={2} />
              Официално партньорство · Издание 2026
            </div>
          </div>
          <div className="col-span-12 md:col-span-5">
            <div className="relative bg-white p-10 flex items-center justify-center min-h-[220px] frame-shadow">
              <img
                src="/partners/ksb.png"
                alt="КСБ — Камара на строителите в България"
                className="max-h-24 sm:max-h-28 w-auto object-contain"
              />
              <div className="absolute -bottom-3 left-6 bg-[#F5892E] text-[#0B1F3D] px-4 py-2 font-mono text-[10px] uppercase tracking-[0.32em]">
                Главен партньор
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-4 text-xs font-mono uppercase tracking-[0.28em]">
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Партньор</div>
                <div className="text-[#F5EBD9]">КСБ · Варна</div>
              </div>
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Тип</div>
                <div className="text-[#F5EBD9]">Съорганизатор</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
